import React from 'react';
import cn from 'classnames';
import LineChartGraph from './LineChartGraph';
import HistoChartGraph from './HistoChartGraph';
import type { DataCondition, CompanyValueData } from './ChartLine';
import ChartDataInfo from './ChartDataInfo';
import CustomStockChart from './CustomStockChart';
import ChartVolumeGraph from './ChartVolumGraph';
import useWindowSize from '../../custom-hook/useWindowSize';

interface Props {
  className?: string;
  dataCondition: DataCondition;
  dateRange: Array<Date | null>;
  valueData: Array<CompanyValueData>;
}

export type WindowSize = {
  width: number;
  height: number;
};

const GraphHeader: React.FC<Props> = React.memo(
  ({ className, valueData, dataCondition, dateRange }) => {
    const windowSize: WindowSize = useWindowSize();

    return (
      <div className={cn(className)}>
        {(dataCondition.graphEffect === 'LINE' ||
          dataCondition.graphEffect === undefined) && (
          <div>
            <LineChartGraph
              data={valueData}
              windowSize={windowSize}
              YValue={
                dataCondition.value === undefined ||
                dataCondition.value === null
                  ? 'close'
                  : dataCondition.value.toLowerCase()
              }
            />
          </div>
        )}
        {dataCondition.graphEffect === 'HISTOGRAM' && (
          <HistoChartGraph
            data={valueData}
            windowSize={windowSize}
            YValue={
              dataCondition.value === undefined || dataCondition.value === null
                ? 'close'
                : dataCondition.value.toLowerCase()
            }
          />
        )}
        <CustomStockChart data={valueData} windowSize={windowSize} />
        <ChartVolumeGraph
          data={valueData}
          windowSize={windowSize}
          YValue={
            dataCondition.value === undefined || dataCondition.value === null
              ? 'close'
              : dataCondition.value.toLowerCase()
          }
        />
        <ChartDataInfo
          data={dataCondition}
          dateRange={dateRange}
          valueData={valueData}
        />
      </div>
    );
  },
);

export default GraphHeader;
